/* Mixing Supply Pack auto-add.
 *
 * Adds one $2.50 pack (10 alcohol preps + 10 U-100 syringes) whenever the cart
 * contains a product tagged `needs-mixing`, and takes it back out if every such
 * product leaves the cart.
 *
 * Design notes:
 *  - The trigger is the TAG, not a product list, so peptides added later are
 *    covered with no theme edit. /cart.js does not expose tags, so the cart is
 *    probed via /cart?view=mixcheck (templates/cart.mixcheck.liquid).
 *  - Removal must STICK. Derek: "If people wanna delete it from their cart, they
 *    can." Once we have added it, seeing it gone again means the customer
 *    removed it deliberately, so we record that and stop re-adding for the
 *    session. Without this the pack would silently reappear and feel broken.
 *  - The pack weighs 0 lb on purpose so it never pushes an order over the
 *    free-shipping weight bracket. Do not give it weight.
 */
(function () {
  'use strict';

  var PACK_VARIANT = 51088367648935;
  var ADDED_KEY = 'wl_syringe_added';
  var DECLINED_KEY = 'wl_syringe_declined';
  var busy = false;

  function flag(key) {
    try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
  }
  function setFlag(key, on) {
    try { on ? sessionStorage.setItem(key, '1') : sessionStorage.removeItem(key); } catch (e) {}
  }

  function probe() {
    return fetch('/cart?view=mixcheck', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }

  function refreshCartUI() {
    // On the cart page the markup is server-rendered, so it must be re-fetched.
    // Elsewhere the drawer/count updates on its own next render.
    if (location.pathname.replace(/\/$/, '') === '/cart') location.reload();
    else document.dispatchEvent(new CustomEvent('wl:syringe-updated'));
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return probe().then(function (c) {
      // every mixing product gone -> the pack should go too, and the customer's
      // earlier decision is no longer relevant
      if (!c.needsMixing) {
        setFlag(ADDED_KEY, false);
        setFlag(DECLINED_KEY, false);
        if (c.packQty > 0 && c.packKey) {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: c.packKey, quantity: 0 })
          }).then(refreshCartUI);
        }
        return null;
      }

      if (c.packQty > 0) { setFlag(ADDED_KEY, true); return null; }

      // needs mixing, no pack present
      if (flag(ADDED_KEY)) { setFlag(DECLINED_KEY, true); return null; }  // they removed it
      if (flag(DECLINED_KEY)) return null;

      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: PACK_VARIANT, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return null;
        setFlag(ADDED_KEY, true);
        refreshCartUI();
      });
    }).catch(function () { /* never block the cart on this */ })
      .then(function () { busy = false; });
  }

  // Re-check after any cart mutation the theme or an app performs.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (!busy && typeof url === 'string' && CART_WRITE.test(url)) {
      p.then(function () { setTimeout(sync, 120); }).catch(function () {});
    }
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_WRITE.test(url)) {
      this.addEventListener('load', function () {
        if (!busy) setTimeout(sync, 120);
      });
    }
    return _open.apply(this, arguments);
  };

  /* Wrapping fetch/XHR is NOT sufficient on its own.
   *
   * Product pages add to cart through a native <form method="post" action="/cart/add">,
   * and Cowlendar + Rebuy each wrap window.fetch ahead of us -- on a product page a
   * direct /cart/add.js call was observed to hang inside that interceptor chain and
   * never resolve, so a .then() hook never fires. Sermorelin added from its product
   * page therefore got no pack (Derek, 2026-08-03).
   *
   * So also trigger off the USER ACTION and off page visibility, which are true
   * regardless of which mechanism the theme or an app uses to perform the add.
   */
  function syncSoon(delay) { setTimeout(sync, delay || 900); }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest &&
             e.target.closest('[name="add"], button[type="submit"], input[type="submit"], [data-wl-quiz-variant], .product-form__submit');
    if (!el) return;
    if (el.form && !/\/cart\/add/.test(el.form.getAttribute('action') || '') &&
        !el.closest('product-form') && !el.hasAttribute('data-wl-quiz-variant')) return;
    syncSoon(1200);   // let the theme's own add land first
    syncSoon(3000);   // and once more, for slow app interceptors
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) { syncSoon(1200); syncSoon(3000); }
  }, true);

  // covers the form-POST navigation case and back/forward bfcache restores
  window.addEventListener('pageshow', function () { sync(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
